let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8v3nN")).then(() => parcelRequire('9x85E'));